export const PricingPlan = {
  FREE: 'free',
  BASIC: 'basic',
  ADVANCED: 'advanced',
  PRO: 'pro',
  ENTERPRISE: 'enterprise',
  ALL_IN: 'all-in',
  DIGITAL_EVENTS: 'digital-events',
  WEBINAR: 'webinar',
  WEBINAR_LITE: 'webinar_lite',
  MEDIA_PLUS: 'media_plus'
};

export const SECONDARY_PLAN_LIST = ['media_plus']

export const AVAILABLE_SECONDARY_PLAN = {
  MEDIA_PLUS: SECONDARY_PLAN_LIST[0],
}

export const AVAILABLE_SECONDARY_ADDONS = {
    MEDIA_PLUS_SITE_1: 'MEDIA_PLUS_SITE_1',
    MEDIA_PLUS_VIDEO_25: 'MEDIA_PLUS_VIDEO_25'
}

export const AVAILABLE_SECONDARY_CREDIT_TYPES = {
    MP_VIDEO: 'MP_VIDEO',
    MP_SITE: 'MP_SITE'
}

export const AVAILABLE_SECONDARY_BASE_CREDITS = {
    [AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]: 25,
    [AVAILABLE_SECONDARY_CREDIT_TYPES.MP_SITE]: 1
}

export const SECONDARY_PLAN_CONFIG = {
    [AVAILABLE_SECONDARY_PLAN.MEDIA_PLUS]: {
        isMediaPlus: true,
        hubiloProductType: "MEDIA_PLUS",
        allowedCreditTypes: [AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO, AVAILABLE_SECONDARY_CREDIT_TYPES.MP_SITE],
        baseCredits: {
            [AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]: AVAILABLE_SECONDARY_BASE_CREDITS[AVAILABLE_SECONDARY_BASE_CREDITS.MP_VIDEO],
            [AVAILABLE_SECONDARY_CREDIT_TYPES.MP_SITE]: AVAILABLE_SECONDARY_BASE_CREDITS[AVAILABLE_SECONDARY_BASE_CREDITS.MP_SITE],
        },
        allowedAddons: [
            AVAILABLE_SECONDARY_ADDONS.MEDIA_PLUS_SITE_1,
            AVAILABLE_SECONDARY_ADDONS.MEDIA_PLUS_VIDEO_25,
        ],
    },
    // Other plan like Podcast
}